export default {"src":"/_next/static/media/blackberries.3d06c664.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};